import MultiDatePicker from './MultiDatePicker';

export default MultiDatePicker;
